"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EUserFileType = void 0;
exports.EUserFileType = {
    SEAL: "seal",
};
